import React from 'react';
import { ReactComponent as ImgSvg } from '../../assets/product/web.svg';

export const WebIcon = ({ size = 18, ...rest }) => {
  return (
    <ImgSvg />
  );
};